import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import invoicelocationlistApi from '../../../middleware/api/Invoicing/LocationList/invoicelocationlistApi'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { RootState } from '../../../stateStore'
import {
  GetRemittanceDetailsType,
  RemittanceDetailsListState,
} from '../../../types/Invoicing/RemittanceDetails/remittanceDetailstype'

const remittanceDetails = createAsyncThunk(
  'remittanceDetailsList/remittanceDetails',
  async (_, thunkApi) => {
    try {
      return await invoicelocationlistApi.getRemittanceDetails()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const addInvoiceLocation = createAsyncThunk(
  'remittanceDetailsList/addInvoiceLocation',
  async (name: string, thunkApi) => {
    try {
      return await invoicelocationlistApi.addInvoiceLocation(name)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const deleteInvoiceLocation = createAsyncThunk(
  'remittanceDetailsList/deleteInvoiceLocation',
  async (locationId: number, thunkApi) => {
    try {
      return await invoicelocationlistApi.deleteInvoiceLocation(locationId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialInvoiceLocationState: RemittanceDetailsListState = {
  getRemittanceDetailsList: {} as GetRemittanceDetailsType,
  getCurrencyList: [],
  isLoading: ApiLoadingState.idle,
}

const addInvoiceLocationlistSlice = createSlice({
  name: 'invoicelocations',
  initialState: initialInvoiceLocationState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(remittanceDetails.fulfilled, (state, action) => {
        state.getRemittanceDetailsList = action.payload
        state.isLoading = ApiLoadingState.succeeded
      })
      .addMatcher(
        isAnyOf(
          remittanceDetails.fulfilled,
          addInvoiceLocation.fulfilled,
          deleteInvoiceLocation.fulfilled,
        ),
        (state, action) => {
          state.getRemittanceDetailsList =
            action.payload as GetRemittanceDetailsType
          state.isLoading = ApiLoadingState.succeeded
        },
      )
      .addMatcher(
        isAnyOf(
          remittanceDetails.pending,
          addInvoiceLocation.pending,
          deleteInvoiceLocation.pending,
        ),
        (state) => {
          state.isLoading = ApiLoadingState.loading
        },
      )
  },
})

const isLoading = (state: RootState): LoadingState =>
  state.addinvoicelocation.isLoading
const invoiceslocations = (state: RootState): GetRemittanceDetailsType =>
  state.addinvoicelocation.getRemittanceDetailsList

const invoiceLocationListThunk = {
  remittanceDetails,
  addInvoiceLocation,
  deleteInvoiceLocation,
}

const invoiceLocationListSelectors = {
  isLoading,
  invoiceslocations,
}

export const invoicelocationService = {
  ...invoiceLocationListThunk,
  actions: addInvoiceLocationlistSlice.actions,
  selectors: invoiceLocationListSelectors,
}

export default addInvoiceLocationlistSlice.reducer
